const initialState = {
  loading: false,
  imageURI: [],
  balanceOf: 0,
  unload: true,
  error: false,
  errorMsg: "",
};

const dataStakeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATASTAKE_REQUEST":
      return {
        ...state,
        loading: true,
        unload: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATASTAKE_SUCCESS":
      return {
        ...state,
        loading: false,
        // tokenURI: action.payload.tokenURI,
        imageURI: action.payload.imageURI,
        balanceOf: action.payload.balanceOf,
        unload: false,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATASTAKE_FAILED":
      return {
        ...initialState,
        loading: false,
        unload: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataStakeReducer;
